import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LaunchpadCard } from 'src/components/ui/LaunchpadCard';

import { isSmallMobileDeviceQuery } from 'src/util/responsive';
import { useMediaQuery } from 'usehooks-ts';
import { FloorplanDescriptionTextField } from '../atomic-components/FloorplanDescriptionTextField';
import { FloorplanImageSelector } from '../atomic-components/FloorplanImageSelector';

interface Props {
  disabled: boolean;
}

export const AssetFloorplanDescription: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();
  const isSmallMobileDevice = useMediaQuery(isSmallMobileDeviceQuery);

  return (
    <LaunchpadCard title={t('dashboard.assets.addedit.main.floorplandescription.title')}>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: isSmallMobileDevice ? '1fr' : '1fr 1fr',
          columnGap: isSmallMobileDevice ? 'unset' : '1.5rem',
        }}
      >
        <FloorplanDescriptionTextField disabled={disabled} />
        <FloorplanImageSelector disabled={disabled} />
      </div>
    </LaunchpadCard>
  );
};
